import { connect } from 'react-redux';

import {
  clearGuestCollectionTempImg,
  clearGuestCollectionSavedImg,
} from 'actions/GuestCollectionActions';
import { clearUploadCareFiles } from 'actions/UploadcareActions';
import type { GuestCollectionActionTypes } from 'actions/types/GuestCollectionActionTypes';
import { getGuestCollectionTempImg, getGuestCollectionSavedImg } from 'selectors/guestCollection';
import type { AppDispatch, RootState } from '../../../../../reducers';
import type { GuestCollectionReducerStateType } from '../../../../../reducers/guestCollection';

import ConfigureAddressCollectionPhotoUploader from './ConfigureAddressCollectionPhotoUploader';

export type ConfigureAddressCollectionPhotoUploaderStateProps = {
  tempImg: GuestCollectionReducerStateType['tempImg'];
  guestCollectionImg?: string;
};

const mapStateToProps = (state: RootState): ConfigureAddressCollectionPhotoUploaderStateProps => ({
  tempImg: getGuestCollectionTempImg(state),
  guestCollectionImg: getGuestCollectionSavedImg(state),
});

export type ConfigureAddressCollectionPhotoUploaderDispatchProps = {
  clearImage: () => GuestCollectionActionTypes;
};

const mapDispatchToProps = (
  dispatch: AppDispatch
): ConfigureAddressCollectionPhotoUploaderDispatchProps => ({
  clearImage: (): GuestCollectionActionTypes => {
    dispatch(clearUploadCareFiles());
    dispatch(clearGuestCollectionSavedImg());
    return dispatch(clearGuestCollectionTempImg());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfigureAddressCollectionPhotoUploader);



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/addressCollection/ConfigureAddressCollectionPhotoUploader/index.ts